var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var _excluded = ["isActive", "icon", "children"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
import React from "react";
import { ArrowLightIcon, ZeroPercentIcon, RiskFreeRentalIcon, FreeReturnIcon, ShippingIcon, CustomerIcon } from "@riseart/icons";
import { tabsActiveCls, tabsItemContentCls, tabsIconCls, tabsTitleCls } from "./Tabs.less";
function BoxTabsItem(_ref) {
  var isActive = _ref.isActive, icon = _ref.icon, children = _ref.children, restProps = _objectWithoutProperties(_ref, _excluded);
  var ICON_MAPPER = {
    "zero-percent": ZeroPercentIcon,
    "riskfree-rental": RiskFreeRentalIcon,
    "free-return": FreeReturnIcon,
    shipping: ShippingIcon,
    customer: CustomerIcon
  };
  var IconComponent = ICON_MAPPER[icon] || null;
  return /* @__PURE__ */ React.createElement("li", _extends({}, restProps, isActive ? {
    className: tabsActiveCls
  } : {}), /* @__PURE__ */ React.createElement("span", {
    className: tabsItemContentCls
  }, IconComponent && /* @__PURE__ */ React.createElement(IconComponent, {
    className: tabsIconCls
  }), /* @__PURE__ */ React.createElement("span", {
    className: tabsTitleCls
  }, children)), /* @__PURE__ */ React.createElement(ArrowLightIcon, null));
}
__name(BoxTabsItem, "BoxTabsItem");
export {
  BoxTabsItem
};
